import { render, staticRenderFns } from "./addAtmosphere.vue?vue&type=template&id=5ac595ee&scoped=true"
import script from "./addAtmosphere.vue?vue&type=script&lang=js"
export * from "./addAtmosphere.vue?vue&type=script&lang=js"
import style0 from "./addAtmosphere.vue?vue&type=style&index=0&id=5ac595ee&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac595ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac595ee')) {
      api.createRecord('5ac595ee', component.options)
    } else {
      api.reload('5ac595ee', component.options)
    }
    module.hot.accept("./addAtmosphere.vue?vue&type=template&id=5ac595ee&scoped=true", function () {
      api.rerender('5ac595ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/atmosphere/atmosphereList/addAtmosphere.vue"
export default component.exports